var RegistrationConsentBlock = (function (checkboxClasses, labelClasses) {

    var $el = $('<div>');

    var consent = $('[id$="siteData"]').data('consent');
    var pt = window.GetPageTemplate || window.kos && window.kos.getPageTemplate || window.PageTemplates && window.PageTemplates.get;
    var validate = function () { };

    if (consent.RAMode == 1) {
        var switchUnion = new Switch({
            defaultValue: consent.RAUnionCheckboxTicked,
            trueText: pt('js_Yes'),
            falseText: pt('js_No'),
            label: pt('_consentWithRegistrationTermsText'),
            testClass: 'test-signup-form-union-switch'
        });

        switchUnion.appendTo($el);

        validate = function () {
            return {
                tcAccepted: switchUnion.getValue(),
                emailsAccepted: switchUnion.getValue()
            };
        };
    } else {
        var switchTC = new Switch({
            defaultValue: consent.RATermsAndConditionCheckboxTicked || null,
            trueText: pt('js_Yes'),
            falseText: pt('js_No'),
            label: pt('_consentWithTCText'),
            testClass: 'test-signup-form-tac-switch'
        });
        var switchEmail = new Switch({
            defaultValue: consent.RAReceiveEmailsCheckboxTicked || null,
            trueText: pt('js_Yes'),
            falseText: pt('js_No'),
            label: pt('_consentWithEmailsText'),
            testClass: 'test-signup-form-emails-switch'
        });

        switchTC.appendTo($el);
        switchEmail.appendTo($el);

        validate = function (separator) {
            var tcAccepted = switchTC.getValue();
            var emailsAccepted = switchEmail.getValue();
            var message = [];

            !tcAccepted && message.push(pt('_consentWithRegistrationTermsWarning'));
            emailsAccepted == null && message.push(pt('_consentWithRegistrationEmailWarning'));

            return {
                tcAccepted: tcAccepted,
                emailsAccepted: emailsAccepted,
                message: message.length && message.join(separator) || null
            }
        };     
    }

    return {
        appendTo: function ($container) {
            $container.html($el);
        },
        validate: validate
    };
});